export const SPLASH = "home";
export const HOME = 'test-of-the-modules';
export const HOME_RESSOURCES = 'table-of-contents';
export const DASHBOARD = 'dashboard';
export const COMING_SOON = 'module-features';
export const LOGOUT = 'logout';
export const GALLERY = 'galerie';
export const GAME = 'activity';
export const EAN13 = '3133097389943';